import GA4Event from "@analytics/GoogleAnalytics/GA4Event";
import { analytics } from "@firebase-local/firebase";

export const GA4UserProperties = {
    subscription_status: {
        key: "subscription_status",
        /** @deprecated */
        pro: "pro",
        /** @deprecated */
        trial: "trial",
        /** @deprecated */
        free: "free",
        /** @deprecated Premium users were never paid, only attained status by referring other users */
        premium: "premium",
    },
    user_type: "user_type", // Map to UserType.ts
};

export const setUserId = (userId: string) => {
    if (process.env.CLIENT_LOG === "true") {
        console.log(`GA4 Set User Id`);
    }
    analytics.setUserId(userId);
};

export const unsetUserId = () => {
    if (process.env.CLIENT_LOG === "true") {
        console.log(`GA4 UN-set User Id`);
    }
    analytics.setUserId(null);
};

export const setUserProperty = (propKey: string, propVal: string | number | boolean) => {
    if (process.env.CLIENT_LOG === "true") {
        console.log(`GA4 Set User Property: ${propKey} : ${propVal}`);
    }
    analytics.setUserProperties({ [propKey]: propVal });
};

export const setUserProperties = (props: { [id: string]: string | number | boolean }) => {
    if (process.env.CLIENT_LOG === "true") {
        console.log(`GA4 Set User Properties: ${JSON.stringify(props)}`);
    }
    analytics.setUserProperties(props);
};

export const logEvent = (event: GA4Event, params?: {}) => {
    if (process.env.CLIENT_LOG === "true") {
        console.log(`GA4 Log Event: ${event} ${params ? `[Props: ${JSON.stringify(params)}]` : ""}`);
    }
    analytics.logEvent(event.toString(), params);
};

export const logWidgetEvent = (widgetEvent: GA4Event, widgetParams?: {}) => {
    logEvent(GA4Event.WIDGET_INTERACT);
    logEvent(widgetEvent, widgetParams);
};

export const logSpaceEvent = (spaceEvent: GA4Event, spaceParams?: {}) => {
    logEvent(GA4Event.SPACE_EVENT);
    logEvent(spaceEvent, spaceParams);
};
